<template>
  <div class="content pt-0 pr-2">
    <div class="columns">
      <div class="column is-12 pt-0">
        <div class="columns">
          <div class="column is-6">
            <label class="label is-size-7-touch">What area is your Bar or Restaurant in?</label>
            <label class="label is-size-7-touch">What City is it in?</label>
            <div class="dropdown is-active is-fullwidth">
              <div class="field has-addons is-fullwidth is-marginless">
                <div class="control is-fullwidth">
                  <input
                    v-model="value"
                    placeholder=""
                    class="input"
                    type="text"
                    @keydown.enter="getData()"
                  >
                </div>
                <div
                  class="control"
                  @click="getData()"
                >
                  <a class="button is-black">
                    <span class="icon is-right">
                      <i class="far fa-search" />
                    </span>
                  </a>
                </div>
              </div>
              <div
                v-if="searchHire.length > 0"
                class="dropdown-menu search-result is-paddingless"
              >
                <div
                  v-for="item in searchHire"
                  class="dropdown-item"
                  @click="value = item.fullname"
                >
                  {{ item.fullname
                  }}
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="show"
            class="column is-4"
          >
            <div
              class="box"
              style="width: 250px"
            >
              <strong>{{ contact['contact_name'] }}</strong>
              <br>
              <p v-for="email in contact['contact_email'].split(';')">
                <a class="link"><i
                  class="far fa-envelope-open-o"
                /> {{ email }}</a>
              </p>
              <p><strong><i class="far fa-mobile-phone" /> {{ contact['contact_phone'] }}</strong></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h1 class="has-text-centered">
      Start running AHL Poker and turn those slow nights around!
    </h1>
    <hr>
    <p>
      Official AHL Poker No Limit Texas Hold'em Tournaments are a form of entertainment designed to fill your
      establishment with customers that will enjoy your products and services. We license to participating restaurants,
      bars, and any place where food and beverages are sold. Founded in Dallas, Texas in 2006, AHL Poker set out to
      create a new era for amateur Texas Hold’em players and help participating establishments put an end to their slow
      nights.
    </p>
    <p>
      Player participation range from 35 to 200 players in a single tournament session and AHL Poker provides venues
      with a professional AHL host and all the equipment needed to run the tournaments and accommodate these players.
      The top 16 players at each session earn Official AHL Poker Player Points which qualify them for big prizes
      throughout the year.
    </p>
    <strong> Is it Legal?</strong>
    <p>
      YES! Our players NEVER pay anything to play! No member fees, no cover charges, and no buy-ins ever! We conduct
      legal research monthly to insure our services fall within the boundaries of local, state and federal laws.
    </p>
    <p>
      Many leagues will use illegal tactics to boost sales. However, it's your establishment that's put at risk because
      Law Enforcement such as TABC only go after those that possess the liquor license not the league itself so be
      careful of leagues that promise to boost your sales using tactics such as, chips for each drink purchased, chips
      for any monetary value, raffles etc.
    </p>
    <p>
      Keep your business and liquor license safe! If you want to read details on what makes poker games in your business
      legal or illegal and all state laws pertaining, please click the "Read More" button.
    </p>
    <a
      v-if="!expand"
      class="button is-info"
      @click="expand = !expand"
    >READ MORE</a>
    <div v-if="expand">
      <strong>Poker in restaurants and bars</strong>
      <p>
        <span class="tag is-danger">ILLEGAL</span>: Players pay a fee of any kind to play in the tournament. The
        establishment charges a door fee or require any minimum purchase of food or beverage for entry into the
        tournament or chance to win the prize. If a league tells you, they can give chips for every drink purchased or
        purchasing multiple gift cards etc. they are wrong and putting your establishment at risk of fines and loss of
        liquor license. It profits only from any discretionary sales of any food or beverage to the players, no gambling
        is otherwise allowed.
      </p>
      <p>
        <span class="tag is-info">LEGAL</span>: The play of the tournament is the same as in the first.  However,
        players neither pay an entry fee nor are charged a door fee or otherwise required to pay the establishment
        anything.  Again, the establishment only profits from discretionary sales of food or beverage to the players. 
        At the end of the tournament prizes put up directly or indirectly by the establishment are awarded to the top
        finishers.
        On June 20, 2005, the Texas Attorney General issued his Opinion No. GA-0335, which concluded:
        "A holder of an on-premises alcoholic beverage permit may not, without violating both section 47.04(a) of the
        Penal Code and Rule 35.31 of the Alcoholic Beverage Commission, host a poker tournament in which participants
        risk money or any other thing of value for the opportunity to win a prize. A holder of an on-premises alcoholic
        beverage permit may, without violating either section 47.04(a) of the Penal Code or Rule 35.31 of the Alcoholic
        Beverage Commission, host a poker tournament in which participants do not risk money or any other thing of value
        for the opportunity to win a prize."
      </p>
      <p>
        The Texas Attorney General has stated that as long as participants do not risk money or anything of value to try
        to win any prize, the game is not illegal under §47.02, which is how bars and restaurants hold legal
        tournaments. 7 Texas Penal Code §47.02(a)(3) states that a person commits an offense if he plays and bets for
        money or other thing of value at any game played with cards, dice, balls, or any other gambling device.
      </p>
      <strong>
        Charity poker: Please read and understand why we cannot be involved in charity events outside our own 501c. If
        you have an idea for a charity event, please make sure it meets the guidelines below.
      </strong>
      <br>
      <br>
      <p>
        The Charitable Raffling Enabling Act in Chapter 2002 of the Texas Occupations Code will rarely, if ever, apply
        to Texas Hold ‘Em fundraisers. Often, the business or association holding the event does not meet the
        requirements of a qualified organization (non-profits, fire departments, emergency medical services, and
        education). Even if the organization meets the stipulated requirements, the charity exception requires that a
        raffle be conducted to award prizes. Because a raffle is defined as “the award of one or more prizes by chance
        at a single occasion among a single pool or group of persons who have paid or promoted a thing of value for a
        ticket that represents a chance to win a prize,”9 players are prohibited from receiving prizes based on how far
        they advance or what place they finish in a poker tournament. Additionally, the code prohibits cash as a prize.
        The Attorney General has also made it clear that even nonprofit organizations that sponsor a “poker run” violate
        gambling statutes.10 Therefore, unless the raffle results are separate from the outcome of the poker
        tournament—begging the question, why play at all? Charities and other groups should not rely on Texas Hold ‘Em
        tournaments to raise funds.
      </p>
    </div>
    <a
      v-if="expand"
      class="button is-info"
      @click="expand = !expand"
    >HIDE</a>
    <br>
    <br>
    <p>
      <strong>Is my place a good fit?</strong>
      <br>
      Your place is a good fit if you have: Physical space for 5 to 16 tables that can seat 8 players each. A slow day
      or evening is where you will see the greatest impact.
    </p>
    <p>
      <strong>How does this help Customers?</strong>
      <br>
      Players can play for free and have fun while testing their poker skills in a live tournament, all in the comfort
      of their favorite neighborhood bars and restaurants. AHL will also be bringing an established member base to your
      establishment on a nightly basis. Make sure you have a wait staff that is up to the challenge to take all those
      drink and food orders prior to and during tournament play. Your slow night may be become your busy night sooner
      than you think!
    </p>
    <p>
      <strong>What's in it for my business?</strong>
      <br>
      Increased sales on tournament nights! Players will spend 2 to 7 hours in your establishment. Most venue owners
      report significant increases in food and beverage sales on tournament nights within the first week! A night of fun
      for you and your customers and guaranteed repeat business! The benefit of free web/social media advertising to
      bring in more customers! Our highly-exposed Web sites and social media pages lists tournaments, venues and session
      schedules and all participating bars and restaurants receive an internal web page within <a
        href="//www.ahlpoker.com/"
      >AHL Poker.com</a>. Click here for an example.
    </p>
    <p>
      <strong>How much does it cost?</strong>
      <br>
      AHL Full Service Tournament Hosting is as low as $75.00 nightly!
    </p>
    <!--<p>-->
    <!--Contact The offices of AHL Poker at <a href="mailto:sales@ahlpoker.com">sales@ahlpoker.com</a> or call an AHL representative today and someone will be happy to help you schedule a meeting and end your slow nights for good!-->
    <!--</p>-->
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'Join',
    metaInfo: {
      title: 'AHL Poker :: Services'
    },
    data() {
      return {
        value: '',
        expand: false,
        searchHire: '',
        show: false,
        contact: {
          contact_email: 'adam@ahlpoker.com',
          contact_name: 'AHL Poker Inc.',
          contact_phone: '972 978 7313',
          franchiseid: 1
        }
      }
    },
    watch: {
      value(newValue) {
        if (newValue.length > 0) {
          this.search('hire')
        } else {
          this.value = ''
          this.searchHire = ''
        }
      }
    },
    mounted() {
      if (this.$route.params.contact) {
        this.contact = this.$route.params.contact
        this.show = true
      }
    },
    methods: {
      getData() {
        this.validation = false
        if (!this.value) {
          this.validation = true
          return
        }
        this.$axios({
          method: 'GET',
          url: `general/franchisecitysearch/${this.value}`
        })
          .then((res) => {
            this.show = true
            this.contact = res.data
          })
          .catch((error) => {
            this.$emit('message', {error: true,showDialog: true, message: error.response.data.message})
          })
      },
      search(route) {
        let url = `general/citysearch/${this.value}`
        this.$axios({
          method: 'GET',
          url
        })
          .then((res) => {
            if (res.data.length === 1 && res.data[0].fullname === this.value) {
              this.searchHire = ''
            } else this.searchHire = res.data
          })
          .catch((error) => {
            this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
          })
      }
    }
  }
</script>
